module.exports = __webpack_public_path__ + "img/ez-slot-default-bg.f8c254a0.f8c254a0.png";